const styles = ({ BREAKPOINTS }) => ({
  container: {
    width: '100%',
    background: '#fff',
    boxShadow: '0 2px 2px 3px rgba(0, 0, 0, 0.08)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '15px 24px',
    zIndex: 10,
    '& > button': {
      marginLeft: '10px'
    }
  },
  discussionButton: {
    display: 'none',
    [`@media (min-width: ${BREAKPOINTS.SM})`]: {
      display: 'inline-flex'
    }
  }
})

export default styles
